<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">クーポン</h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <template slot="title"> クーポン一覧 </template>
            <CouponListTable CouponStatus="0,1,10,15,20,99" />            
          </CCardBody>
          <CCardFooter class="px-5"> </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <!-- Complete Dialog ↑↑↑ -->
  </div>
</template>

<script>
// import Vue from 'vue'
import CouponListTable from "./components/CouponListTable.vue";

export default {
  name: "Coupons",
  components: {
    CouponListTable,
    // DateDropdown,
  },
  data() {
    return {
      linkD: "",
      discountTab: false,
      allTab: false,
      testDate: 30,
    };
  },
  created() {
    this.linkD = this.$route.params.listTab;
    this.linkD == "copon-discount"
      ? (this.discountTab = true)
      : (this.allTab = true);
  },
  methods: {},
};
</script>
<style lang="scss">
.nav-tabs {
  margin-bottom: -1px;
  .nav-link {
    border: 1px solid #cccccc;
    color: #4b5e80;
    &.active {
      background: #cccccc;
      border: 1px solid #cccccc;
      color: #454579;
      font-weight: bold;
    }
  }
}
</style>
